import { Button, cn } from '@ds';

type AssignButtonProps = {
  isSelected: boolean;
  isDisabled: boolean;
  onAssign: () => void;
};

export const AssignButton = ({ onAssign, isSelected, isDisabled }: AssignButtonProps) => {
  return (
    <Button
      variant="outline"
      className={cn('flex flex-row items-center text-s-sb h-8 w-20', {
        'text-danger-30 border-danger-30': isSelected,
      })}
      onClick={onAssign}
      isDisabled={isDisabled}
    >
      {isSelected ? 'Detach' : 'Assign'}
    </Button>
  );
};
